import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_DOKUMENT_HINZUFUEGEN = '[VeranstaltungenModul] PostDokumentHinzufuegen laden';
export const POST_DOKUMENT_HINZUFUEGEN_AUSFUEHREN = '[VeranstaltungenModul] PostDokumentHinzufuegen ausführen';
export const POST_DOKUMENT_HINZUFUEGEN_ERFOLGREICH = '[VeranstaltungenModul] PostDokumentHinzufuegen laden erfolgreich';
export const POST_DOKUMENT_HINZUFUEGEN_FEHLER = '[VeranstaltungenModul] PostDokumentHinzufuegen Ladefehler';
export const POST_DOKUMENT_HINZUFUEGEN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostDokumentHinzufuegen nicht ausgeführt (evtl. Offline)';


export class PostDokumentHinzufuegenAction implements Action {
    readonly type = POST_DOKUMENT_HINZUFUEGEN;
        constructor(public dokumentHinzufuegenRequest: api.DokumentHinzufuegenRequest, public optPayload: any = null) {}
    }
export class PostDokumentHinzufuegenAusfuehrenAction implements Action {
    readonly type = POST_DOKUMENT_HINZUFUEGEN_AUSFUEHREN;
        constructor(public dokumentHinzufuegenRequest: api.DokumentHinzufuegenRequest, public optPayload: any = null) {}
    }
export class PostDokumentHinzufuegenErfolgreichAction implements Action {
    readonly type = POST_DOKUMENT_HINZUFUEGEN_ERFOLGREICH;
        constructor(public payload: api.DokumentIdentifier, public dokumentHinzufuegenRequest: api.DokumentHinzufuegenRequest, public optPayload: any = null) {}
    }
export class PostDokumentHinzufuegenFehlerAction implements Action {
    readonly type = POST_DOKUMENT_HINZUFUEGEN_FEHLER;
        constructor(public payload: any, public dokumentHinzufuegenRequest: api.DokumentHinzufuegenRequest, public optPayload: any = null) {}
    }
export class PostDokumentHinzufuegenNichtAusgefuehrtAction implements Action {
    readonly type = POST_DOKUMENT_HINZUFUEGEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandDokumentHinzufuegenActions =
    PostDokumentHinzufuegenAction
    | PostDokumentHinzufuegenAusfuehrenAction
    | PostDokumentHinzufuegenErfolgreichAction
    | PostDokumentHinzufuegenFehlerAction
    | PostDokumentHinzufuegenNichtAusgefuehrtAction
    ;
